import Row from 'react-bootstrap/Row';

export default function returnTitle(stage, signInType) {
    const subtitle = stage === "RESET" ? "Password Reset" : "Sign In";
    const titleMap = {
        EMAIL: "Verify By Email",
        PHONE: "Verify By Text",
        OTP: "Sign In with a Temporary Pass Code",
        PASSWORD: <h1 className="title__TO left">Enter your password</h1>,
    };
    const title = titleMap[signInType];

    if (stage === "PASSWORD") {
        return (<Row className="justify-content-center">{title}</Row>);
    }

    return (
        <div>
            <Row className="justify-content-center location">
                <div>{subtitle}</div>
            </Row>
            <Row className="justify-content-center">
                <div className="title__TO left">{title}</div>
            </Row>
        </div>
    );
}